import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Button, Box } from '@mui/material';
import logoImage from '../Images/tw logo.svg';

const Navbar = ({ 
  onLogoClick, 
  onJoinClick, 
  isMobile = false 
}) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
    if (onLogoClick) onLogoClick();
  };

  return (
    <Grid
      container
      sx={{
        position: "fixed",
        top: 5,
        left: 0,
        right: 0,
        backgroundColor: "rgba(0, 0, 0, 0.1)", 
        padding: isMobile ? "10px 20px" : "10px 40px",
        zIndex: 10,
        width: '100%'
      }}
      alignItems="center"
      justifyContent="space-between"
    >
      {/* Logo */}
      <Grid item>
        <Box
          component="img"
          src={logoImage}
          alt="Towerwatch Logo"
          onClick={handleLogoClick}
          sx={{
            height: isMobile ? "25px" : "40px",
            objectFit: "contain",
            cursor: "pointer",
            marginTop: "5px",
          }}
        />
      </Grid>

      {/* Join Button */}
      <Grid item>
      <Button
  variant="contained"
  onClick={() => window.open('https://app.towerwatch.io', '_blank')}
  sx={{
    backgroundColor: "transparent",
    color: "#fff",
    fontSize: isMobile ? "10px" : "12px",
    fontWeight: "regular",
    textTransform: "none",
    width: isMobile ? "85px" : "100px",
    height: isMobile ? "27px" : "35px",
    fontFamily: "Raleway",
    padding: "8px 16px",
    borderRadius: "10px",border: "1px solid #FFFFFF",
            "&:hover": {
              backgroundColor: "#000000",
              color: "#FFFFFF",
              border: "1px solid #000000",
    },
    marginRight: "10px"
  }}
>
  Go to App
</Button>
        <Button
          variant="contained"
          onClick={onJoinClick}
          sx={{
            backgroundColor: "transparent",
            color: "#fff",
            fontSize: isMobile ? "10px" : "12px",
            fontWeight: "regular",
            textTransform: "none",
            width: isMobile ? "78px" : "100px",
            height: isMobile ? "27px" : "35px",
            fontFamily: "Raleway",
            padding: "8px 16px",
            borderRadius: "10px",border: "1px solid #FFFFFF",
            "&:hover": {
              backgroundColor: "#000000",
              color: "#FFFFFF",
              border: "1px solid #000000",
            },
          }}
        >
          Join us
        </Button>
      </Grid>
    </Grid>
  );
};

export default Navbar;